<!--分页-->
<template>
  <div class="pager">
    <el-pagination @current-change="handleCurrentChange"
                   :current-page="page.number"
                   :page-size="page.size"
                   layout="total, prev, pager, next"
                   :total="page.totalElements">
    </el-pagination>

  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    page: Object
  },
  methods: {
    handleCurrentChange (val) {
      this.page.number = val
      this.$emit('load')

    },
    handleSizeChange (val) {
      //console.log(`每页 ${val} 条`);
    },
    // handleCurrentChange (val) {
    //   this.page.number = val
    //   this.$emit('load')
    // }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
.pager {
  margin-top: 10px;
  padding: 0 5px;
  > .el-pagination {
    text-align: right;
    > .el-pagination__total {
      float: left;
    }
  }
}
</style>